// Permission codes used to filter the sidebar per spec §4.1 + §RB:
// "Sidebar chỉ hiện menu user có quyền". OWNER/ADMIN see everything;
// MEMBER sees only items whose code is in their permission_codes.
//
// Codes mirror backend/deploy/authoriz/authoriz.json — keep this enum in
// lock-step with that file (and bootstrap/bootstrap.go's permData) so a new
// menu item can be gated without inventing a code the BE doesn't grant.
export enum MenuRole {
  cfg_xem = 'CFG_XEM',
  dut_ql = 'DUT_QL',
  khtd_xem = 'KHTD_XEM_DANH_SACH',
  npnv_xem = 'NPNV_XEM',
  qlkh_xem = 'QLKH_XEM_DANH_SACH',
  qln_xem = 'QLN_XEM_DANH_SACH',
  qlnld_xem = 'QLNLD_XEM_DANH_SACH',
  qlnm_xem = 'QLNM_XEM',
  qlq_xem = 'QLQ_XEM_DANH_SACH',
  // ADMIN vs MEMBER are separate buckets; HR list reachable if either is set.
  qltkadmin_xem = 'QLTKADMIN_XEM_DANH_SACH',
  qltkmem_xem = 'QLTKMEM_XEM_DANH_SACH',
  qltt_ht = 'QLTT_HT',
  qltt_ksl = 'QLTT_KSL',
  qltt_kstd = 'QLTT_KSTD',
  rp_xem = 'RP_XEM',
  tb_gui = 'TB_GUI',
  tckt_xem = 'TCKT_XEM',
  tctd_xem = 'TCTD_XEM_DANH_SACH',
  vhnld_ql = 'VHNLD_QL',
  vl_xem = 'VL_XEM',
  vphm_xem = 'VPHM_XEM',
}
